import React from 'react'

export const StudentBloxSelection = [
  {
    name: 'Escolha de Bloxes',
    component: React.lazy(() => import('../../modules/ecommerceStudent/BloxSelection/Enrollments')),
    path: '/ecommerce-student/old-enrollments',
    guards: ['allowOnlyEcommerceStudent', 'allowOnlyLogged'],
  },
  {
    name: 'Escolha de Bloxes',
    component: React.lazy(() => import('../../modules/ecommerceStudent/BloxSelection/Enrollments')),
    path: '/ecommerce-student/schedule',
    guards: ['allowOnlyEcommerceStudent', 'allowOnlyLogged'],
  },
  {
    name: 'Escolha a oferta',
    component: React.lazy(() => import('../../modules/ecommerceStudent/BloxSelection/BloxOfferings')),
    path: '/ecommerce-student/old-enrollments/:enrollmentId',
    guards: ['allowOnlyEcommerceStudent', 'allowOnlyLogged'],
  },
  {
    name: 'Confirmação de Escolhas',
    component: React.lazy(() => import('../../modules/ecommerceStudent/BloxSelection/BloxConfirmation')),
    path: '/ecommerce-student/old-enrollments/:enrollmentId/blox_confirmations',
    guards: ['allowOnlyEcommerceStudent', 'allowOnlyLogged'],
  },
  {
    name: 'Grade Horária',
    component: React.lazy(() => import('../../modules/ecommerceStudent/Schedule')),
    path: '/ecommerce-student/schedule/:enrollmentId',
    guards: ['allowOnlyEcommerceStudent', 'allowOnlyLogged'],
  },
]
